import type { ChatMessage } from "./messages.js";
import type { AgentRoom } from "./nav.js";

/** Persona for specialist rooms or the master Mairko chat. */
export type ChatPersona = Pick<
	AgentRoom,
	| "name"
	| "department"
	| "title"
	| "lede"
	| "initials"
	| "avatar"
	| "avatar2x"
> & { id: string };

/** Front-desk persona for the master ChatGPT-style surface. */
export const MAIRKO_CHAT: ChatPersona = {
	id: "mairko",
	name: "Mairko",
	department: "Front desk",
	title: "Your marketing team in chat",
	lede: "Ask anything — I’ll route specialists, draft work, and check with you before spending.",
	initials: "Mk",
	avatar: null,
	avatar2x: null,
};

export function mairkoWelcomeMessages(): ChatMessage[] {
	const now = Date.now();
	return [
		{
			id: "mairko-welcome-1",
			agentId: "mairko",
			author: "agent",
			authorName: MAIRKO_CHAT.name,
			body: "Hey — I’m Mairko. This is the main chat for your desk. Ask about ads, analytics, content, or who’s on your roster — I’ll help and pull in specialists when it matters.\n\nSpend and public posts still need your approval.",
			at: new Date(now - 2_000).toISOString(),
		},
	];
}

